<template>
  <ContentBox :title="'每日任务'">
    <div class="daily-tasks">
      <div class="tasks-content">
        <!--任务进度-->
        <div class="task-progress">
          <div class="gift">
            <img src="@/assets/black_imgs/gift.png" alt="" />
          </div>
          <div class="gift-info">
            <div class="gift-text">
              <div class="outpost-defense">OUTPOST DEFENSE</div>
              <div class="gift-num">{{ basicInfo.outpost_defense }}%</div>
            </div>
            <div class="gift-progress">
              <div class="progress-bar" :style="{ width: basicInfo.outpost_defense + '%' }"></div>
            </div>
          </div>
        </div>
        <!--任务活跃度-->
        <div class="task-liveliness">
          <img src="@/assets/black_imgs/star.png" alt="" class="task-star" />
          <div class="treasure" v-for="item in 5" :key="item">
            <div class="treasure-box">
              <div class="liveliness-progress">
                <div class="progress-bar" :style="{ width: basicInfo.player_activity }"></div>
              </div>
              <img src="@/assets/black_imgs/chest.png" alt="" />
            </div>
            <span class="treasure-num">{{ item * 20 }}p</span>
          </div>
        </div>
        <!--剩余次数-->
        <div class="task-num">
          <div class="common-container">
            <div class="common-box">3/3</div>
            <div class="text-box">
              <div class="text">剩余挑战次数</div>
            </div>
          </div>
          <div class="common-container">
            <div class="common-box">{{ basicInfo.used_rookie_arena }}</div>
            <div class="text-box">
              <div class="text">新人竞技场</div>
              <div class="text-desc">今日挑战次数</div>
            </div>
          </div>
          <div class="common-container">
            <div class="common-box">{{ basicInfo.used_rookie_arena }}</div>
            <div class="text-box">
              <div class="text">特殊竞技场</div>
              <div class="text-desc">今日挑战次数</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ContentBox>
</template>
<script>
import ContentBox from './ContentBox.vue'

export default {
  name: "DailyTask",
  props: {
    basicInfo: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ContentBox
  },
  data() {
    return {
    };
  }
};
</script>
<style scoped lang="less">
.daily-tasks {
  margin-bottom: 10px;
  border-radius: 0 0 10px 10px;

  .tasks-content {
    width: 100%;
    padding: 14px 14px 0 14px;
    background: #fafbfc;
    border-radius: 0 0 10px 10px;

    .task-progress {
      display: flex;
      padding-bottom: 10px;
      border-bottom: 1px solid #d4d4d4;

      .gift {
        width: 32px;
        height: 32px;

        img {
          width: 32px;
          height: 32px;
        }
      }

      .gift-info {
        flex: 1;
        margin-left: 6px;
        display: flex;
        flex-direction: column;

        .gift-text {
          display: flex;
          justify-content: space-between;

          .outpost-defense {
            font-weight: 400;
            font-size: 12px;
            color: #333333;
          }

          .gift-num {
            font-weight: 600;
            font-size: 16px;
            color: #333333;
          }
        }

        .gift-progress {
          position: relative;
          width: 100%;
          margin-top: 5px;
          height: 4px;
          background: #c0c0c0;

          .progress-bar {
            position: absolute;
            height: 4px;
            top: 0;
            left: 0;
            background: #059cff;
          }
        }
      }
    }

    .task-liveliness {
      position: relative;
      display: grid;
      grid-template-columns: auto repeat(5, 1fr);
      width: 100%;
      padding: 10px 0;

      .task-star {
        width: 21px;
        height: 21px;
      }

      .treasure {
        display: flex;
        flex-direction: column;
        text-align: center;

        .treasure-box {
          display: flex;
          align-items: center;

          .liveliness-progress {
            position: relative;
            height: 4px;
            background: #c0c0c0;
            flex: 1;
          }

          img {
            width: 21px;
            height: 21px;
          }
        }

        .treasure-num {
          font-weight: 400;
          font-size: 10px;
          color: #000000;
          padding-top: 4px;
          text-align: right;
        }
      }
    }

    .task-num {
      margin-top: 10px;
      width: 100%;
      height: 80px;
      background: #f3f4f5;
      display: grid;
      grid-template-columns: repeat(3, 1fr);

      .common-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .common-box {
          margin-top: 10px;
          width: 46px;
          height: 31px;
          background: url("~@/assets/black_imgs/num_bg.png") no-repeat;
          background-size: 100% 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .text-box {
          flex: 1;
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;

          .text {
            font-weight: 400;
            font-size: 12px;
            color: #333333;
          }

          .text-desc {
            font-weight: 400;
            font-size: 12px;
            color: rgba(51, 51, 51, 0.7);
            line-height: 16px;
          }
        }
      }
    }
  }
}
</style>
